import React from 'react'
import ExpiryAlerts from './ExpiryAlerts'
import EnterInvoice from './EnterInvoice'

const PlanDetails = () => {

  return (
    <>
      <EnterInvoice />
      <br />
      <ExpiryAlerts />
    </>
  )
}

export default PlanDetails;